
import config from '../../config'

/**
 * @func: getWelfares
 * @return {[Object]} data
 *
 * @description:
 */

const getWelfares = (lan) => {
  const params = { language: lan }
  return config.API.welfaresGet(params, {}, {})
  .then(result => result.data)
  .catch(error => error)
}


export default getWelfares
